import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { useEffect, useRef } from 'react';


function VoiceSearch(setIsKeyDown: React.Dispatch<React.SetStateAction<boolean>>, inputbox: HTMLInputElement | null, sendButton: HTMLInputElement | null, setQmate: React.Dispatch<React.SetStateAction<string>>) {
  const { transcript, resetTranscript, listening } = useSpeechRecognition();
  const silenceTimeoutRef: any = useRef(null);
  const handleStartListening = () => {
    resetTranscript();
    SpeechRecognition.startListening();
    if (sendButton) {
      sendButton.disabled = true // Disable the send button
    }
  };

  const handleStopListening = () => {
    SpeechRecognition.stopListening()
    setIsKeyDown(false);
    // setInputValue(transcript);
    setQmate(transcript);
    // setTimeout(()=>{
    // update_time?.current?.focus();
    // }, 1000)
    // dispatch(setQmateValue(transcript));
    if (inputbox)
      inputbox.removeAttribute('disabled');
    if (sendButton)
      sendButton.removeAttribute('disabled');
  };

  useEffect(() => {
    if (listening) {
      // User is speaking, clear the silence timeout
      clearTimeout(silenceTimeoutRef.current);
    }
    else {
      // User has stopped speaking, start a silence timeout
      silenceTimeoutRef.current = setTimeout(() => {
        handleStopListening();
      }, 500); // Adjust the timeout duration as needed
    }

    return () => {
      clearTimeout(silenceTimeoutRef.current); // Clean up the timeout on unmount
    };
  }, [listening]);


  return {
    handleStartListening,
    handleStopListening,
  };
}

export default VoiceSearch;